module.exports = __webpack_public_path__ + "img/horizontal_4_1_9006.9fe0eaac.png";